<template>
  <Container class="mt-3" >
    <Card>
      <h4>Мои бронирования</h4>

      <ul class="nav nav-underline">
        <li class="nav-item">
          <router-link :to="{ name: 'mybookings' }" class="nav-link" :class="{active: !archive}">
            Активные
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'myarchive' }" class="nav-link" :class="{active: archive}">
            Архив
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'schedule' }" class="nav-link">
            Вернуться в расписание
          </router-link>
        </li>
      </ul>
    </Card>

    <div v-if="!loaded">
      <div class="card  px-1 py-4 p-sm-4 my-3 d-flex flex-row justify-content-center">
        <div>
          <span class="spinner-border spinner-border-sm text-primary me-2"></span>
        </div>
        <div>
          Загружаем...
        </div>
      </div>
    </div>

    <div v-if="loaded && !Object.keys(bookings).length ">
      <div class="card  px-1 py-4 p-sm-4 my-3 d-flex flex-row justify-content-center">
        <div>
          Нет данных
        </div>
      </div>
    </div>

    <div v-for="(bData,date) in sortedBookings" :key="date" class="mt-3">
      <Card class="mb-3">
        <div class="text-center">
          <div>Дата: <span class=" text-primary">{{ dateFormat(date) }}</span></div>
          <div class="text-muted small">{{dateToDay(date)}}</div>
        </div>

        <div>
          <div class="block-office" v-for="(ofData,officeId) in bData" :key="officeId">
            <div class="center-title">Центр: {{ officeTitle(officeId) }}</div>
            <div v-if="officeAfterBooking(officeId) && !this.archive ">
            <OfficeInfoText
                :html="formatedText(officeAfterBooking(officeId))"
                :lines="3.5"
            />
            </div>
            <div>
              <CabinetCard
                  v-for="(cabData, cabId) in ofData"
                  :key="cabId"
                  :cabData="cabinets[cabId]"
                  :date="date"
                  :officeId="officeId"
                  :officeAddress="offices[officeId] && offices[officeId].address ? offices[officeId].address : null"
                  :archive="archive"
                  :bookingData="cabData"
              />
            </div>
          </div>
        </div>
      </Card>
    </div>
    <div class="text-center">
      <button v-if="moreView" @click="more" class="btn btn-sm btn-secondary my-3">
        <span v-show="loadingMore"
              class="booking-filter-loader spinner-border spinner-border-sm text-white me-2"></span>
        Показать еще
      </button>
    </div>

    <widget-container-modal/>
  </Container>


</template>

<script>
import Card from "@/components/Card";
import Container from "@/components/Container";
import {API} from "@/getapi";
import {dateFormat} from "@/dateFormat";
import CabinetCard from "@/components/MyBookings/CabinetCard";
import {container} from "jenesius-vue-modal";
import OfficeInfoText from "@/components/MyBookings/OfficeInfoText.vue";


export default {
  name: "MyBookings",
  inject: ['URL_MYBOOKING','URL_SENDCOMMENT'],
  components: {OfficeInfoText, CabinetCard, Container, Card, WidgetContainerModal: container},
  props: {
    archive: Boolean
  },
  data() {
    return {
      loaded: false,
      loadingMore: false,
      limit: 100,
      moreView: false,
      lastDate: "",
      offices: {},
      cabinets: {},
      bookings: {}
    }
  },
  created() {
    this.$emitter.off('saveComments')
    this.$emitter.on('saveComments', (data) => {

      this.bookings[data.date][data.officeId][data.cabinetId][data.hour + data.minuteView]['comment'] = data.comment;
      this.bookings[data.date][data.officeId][data.cabinetId][data.hour + data.minuteView]['commentTenant'] = data.commentTenant;
      let saveData = {
        'id': data.id,
        'comment': data.comment,
        'commentTenant': data.commentTenant,
      }
      this.sendComment(saveData)

    })
    this.$emitter.off('ChangeBookingsDone')
    this.$emitter.on('ChangeBookingsDone', () => {
      this.getMyBookings()
    })

    this.$store.commit('cabinet/resetData')
    this.getMyBookings()
  },
  watch: {
    archive() {
      this.loaded = false
      this.moreView = false
      this.lastDate = ""
      this.offices = {}
      this.cabinets = {}
      this.bookings = {}
      this.getMyBookings()
    }
  },
  computed: {

    sortedBookings(){
      return this.bookings
      // return Object.keys(this.bookings)
      //     .sort((a, b) => new Date(a) - new Date(b)) // Меняем порядок сортировки
      //     .reduce((acc, key) => {
      //       acc[key] = this.bookings[key];
      //       return acc;
      //     }, {});
    }
  },
  methods: {
    formatedText(msg){
      if(msg){
        return msg.replace(/(?:\r\n|\r|\n)/g, '<br>');
      }
      return '';

    },
    dateToDay(date){
      const d = new Date(date);
      return `${d.toLocaleDateString('ru-RU', { weekday: 'long' })}`;
    },
    cabinetTitle($id) {
      return this.cabinets[$id]['title']
    },
    officeTitle($id) {
      return this.offices && $id in this.offices ? this.offices[$id]['title'] : 'No title'
    },
    officeAfterBooking($id) {
      return this.offices && $id in this.offices ? this.offices[$id]['after_booking_info'] : ''
    },
    dateFormat(date) {
      return dateFormat.strToFormat(date)
    },
    more() {
      this.loadingMore = true;
      this.getMyBookings()

    },
    sendComment(saveData){
      // console.log('sendComment', saveData)
      API.get(this.URL_SENDCOMMENT, saveData).then(({data}) => {

        if (data.isOk) {
          let dataResult = data.result
          console.log(dataResult)
        } else {
          console.error("Error:", data.errors)
        }
      }).catch((err) => {
        API.catch(err)
      })


    },
    getMyBookings() {
      // let _this = this;
      let params = {
        "lastDate": this.lastDate,
        "limit": this.limit,
        "archive": this.archive
      }
      // console.log(params)
      // let _this = this
      API.get(this.URL_MYBOOKING, params).then(({data}) => {

        if (data.isOk) {

          let dataResult = data.result
          // console.log(dataResult)
          let result = data.result.result
          this.bookings = {...this.bookings, ...result.bookings}
          this.offices = {...this.offices, ...result.offices}
          this.cabinets = {...this.cabinets, ...result.cabinets}
          this.lastDate = dataResult.next ? dataResult.lastDate : ''
          this.moreView = dataResult.next
          this.lastDate = dataResult.next ? dataResult.lastDate : ''
          this.loadingMore = false;
          this.loaded = true
        } else {
          console.error("Error:", data.errors)

        }
      }).catch((err) => {
        API.catch(err)
      })
    }
  }
}
</script>
<style>
.btn-change,
.btn-cancel,
.btn-comment {
  font-size: 0.75em;
  border: none;
  padding: 0.5em 1em;
//border-radius: 1em; border-radius: 22px;
  background: #dd9f4c57;
  color: #704a00;
  line-height: 1.35em;
  border: 1px solid #fff;
  box-shadow: inset 0px 0px 0px 1px #34343417;
  text-decoration: none;
  transition: all ease .3s;
}

.btn-comment:hover {
  background: #dd9f4c77;
}

.btn-cancel{
  background: #db2121a3;
  color:#fff;
}

.btn-cancel:hover {
  background: #b11919a3;
}

.btn-change{
  background: #3c6c36a3;
  color:#fff;
}


.btn-change:hover {
  background: rgba(51, 93, 45, 0.64);
}

.btn-send {
  font-size: 0.75em;
  border: none;
  padding: 0.5em 1em;
//border-radius: 1em; border-radius: 22px;
  background: #4caddd57;
  color: #006570;
  line-height: 1.35em;
  border: 1px solid #fff;
  box-shadow: inset 0px 0px 0px 1px #34343417;
  text-decoration: none;
  transition: all ease .3s;
}

.btn-edit {
  display: inline-block;
  text-decoration: none;
  font-size: 0.75em;

  border: none;
  padding: 0.5em 1em;

  border-radius: 22px;
  background: #e07a5fc4;
  color: #fff;
  line-height: 1.35em;
  border: 1px solid #fff;
  box-shadow: inset 0px 0px 0px 1px #34343417;
  transition: all ease .3s;
}

.btn-edit:hover {
  color: #fff;
  background: #b75a42c4;
}

.modal-container {
  background: #3e3e3e6e !important;
  z-index: 3000;
}

.h-card {

  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}

.h-card .card-header {
  display: flex;
  background: #ffe9a580;
  border-bottom: 1px solid #cccccc8f;
  padding: 0.5em;
  justify-content: space-between;
}

.h-card .card-header .modal-title {
  font-size: 1em;
  /*text-shadow: 0px 1px 0px #fff;*/
}

.h-card .card-footer {
  display: flex;
  background: #ebebeb73;
  border-bottom: 1px solid #cccccc8f;
  padding: 0.5em 0.8em;
  justify-content: flex-end;
}

.h-card .card-footer .ok-btn,
.h-card .card-footer .close-btn {
  padding: 0.4em 1em;
  background: #e7e7e7;
  font-size: .8em;
  line-height: 1.75em;
  border-radius: 1.3em;
  border: 1px solid #fff;
  box-shadow: inset 0px 0px 0px 1px #34343417;
  /*text-shadow: 0px 1px 0px #fff;*/
}

.h-card .card-footer .ok-btn {
  background: #ffdfaa;
}

.h-card .card-body {
  padding: 0.8em 0.8em;
}
</style>
<style scoped>
.card-booking {
  background: #fff8da47;
  /*#e8e6681f;*/
  border: 1px solid #f2f2e7;
}

.center-title {
  font-size: .95rem;
  font-weight: bold;
  margin-bottom: .5rem;

}

.block-office {
  margin-top: 1.5rem;
}

.block-office:first-child {
  margin-top: 0.5rem;
}

/*.nav-underline{*/
/*  display: flex;*/
/*  flex-wrap: wrap;*/
/*  gap: 1rem;*/
/*}*/
/*.nav-underline .nav-link {*/
/*  !*padding-right: 0;*!*/
/*  !*padding-left: 0;*!*/
/*  padding: 5px 0;*/
/*  border-bottom: 1px solid transparent;*/
/*}*/

/*.nav-underline .nav-link.active{*/
/*  font-weight: bold;*/
/*  border-bottom: 1px solid;*/
/*  !*color:#333;*!*/
/*}*/

</style>